import { Form } from 'antd';
import type { FormItemProps } from 'antd';
import cn from 'classnames';
import styles from './form-item.module.scss';

type AppFormItemProps = FormItemProps & {
    noMargin?: boolean;
};

export const AppFormItem = ({
    className,
    noMargin,
    children,
    help,
    ...rest
}: AppFormItemProps) => {
    return (
        <Form.Item
            label={false}
            colon={false}
            className={cn(
                styles.item,
                { [styles.noMargin]: noMargin },
                className
            )}
            help={help}
            {...rest}
        >
            {children}
        </Form.Item>
    );
};
